import React, { useContext } from 'react';
import { Flex } from 'antd';

import DeviceSoftwareEndOfLifeSummaryLayout from '@totem/components/devices/softwareEndOfLife/summary/DeviceSoftwareEndOfLifeSummaryLayout';
import DeviceSoftwareEndOfSupportContainer from '@totem/components/devices/softwareEndOfLife/summary/DeviceSoftwareEndOfSupportContainer';
import ComplianceSection from '@totem/components/portfolio/overview/compliance/ComplianceSection';
import ContinuitySection from '@totem/components/portfolio/overview/continuity/ContinuitySection';
import MyWork from '@totem/components/portfolio/overview/myWork/myWork';
import RemoteAccessSection from '@totem/components/portfolio/overview/remoteAccess/RemoteAccessSection';
import SummaryContext from '@totem/components/portfolio/overview/summary/summaryContext';
import SummaryLayout from '@totem/components/portfolio/overview/summary/SummaryLayout';
import ThreatManagementSection from '@totem/components/portfolio/overview/threatManagement/ThreatManagementSection';
import VulnerabilityConditional from '@totem/components/portfolio/overview/vulnerabilities/vulnerabilityConditional';
import BackupSummaryContainer from '@totem/components/services/backup/deviceBackups/backupSummary/backupSummaryContainer';
import RemoteAccessTotalsContainer from '@totem/components/services/remoteAccess/totals/RemoteAccessTotalsContainer';
import EventTotalsContainer from '@totem/components/services/threats/totals/EventTotalsContainer';
import VulnerabilitySummaryContainer from '@totem/components/software/vulnerabilitySummary/vulnerabilitySummaryContainer';
import ComplianceSummaryContainer from '@totem/components/surveyV2/complianceSummary/complianceSummaryContainer';
import {
  hasActiveService,
  hasAnyActiveService,
} from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import DeviceVulnerabilitySummaryContainer from '@totem/components/vulnerabilities/overviewSummary/vulnerabilitySummaryContainer';
const PortfolioLayout = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { selectedRegionIds, selectedBuildingIds } = useContext(SummaryContext);

  let hasCompliance = hasActiveService(userProfile, 'cybersecurity_assessment');
  const hasContinuity = hasActiveService(userProfile, 'backup');
  const hasRemoteAccess = hasActiveService(userProfile, 'remote_access');
  const hasThreatManagement = hasAnyActiveService(userProfile, [
    'threat_management',
    'server_resilience',
  ]);
  const hasRMM = hasAnyActiveService(userProfile, [
    'threat_management',
    'rmm_server',
    'rmm_workstation',
    'rmm',
    'server_resilience',
  ]);
  const hasSoftwareReporting = hasAnyActiveService(userProfile, [
    'software-reporting',
  ]);

  const noServices =
    !hasCompliance &&
    !hasContinuity &&
    !hasRemoteAccess &&
    !hasThreatManagement;

  hasCompliance = hasCompliance || noServices;

  return (
    <Flex vertical justify={'flex-start'} gap={16}>
      <MyWork />
      <SummaryLayout />
      {hasCompliance && (
        <ComplianceSummaryContainer
          regionId={selectedRegionIds}
          buildingId={selectedBuildingIds}
        >
          <ComplianceSection />
        </ComplianceSummaryContainer>
      )}
      {hasCompliance && <ComplianceSection />}
      {hasRemoteAccess && (
        <RemoteAccessTotalsContainer
          regionId={selectedRegionIds}
          buildingId={selectedBuildingIds}
        >
          <RemoteAccessSection />
        </RemoteAccessTotalsContainer>
      )}
      {hasThreatManagement && (
        <EventTotalsContainer
          regionId={selectedRegionIds}
          buildingId={selectedBuildingIds}
        >
          <ThreatManagementSection />
        </EventTotalsContainer>
      )}
      {(hasThreatManagement || hasRMM || hasSoftwareReporting) && (
        <VulnerabilitySummaryContainer
          regionId={selectedRegionIds}
          buildingId={selectedBuildingIds}
        >
          <DeviceVulnerabilitySummaryContainer>
            <VulnerabilityConditional />
          </DeviceVulnerabilitySummaryContainer>
        </VulnerabilitySummaryContainer>
      )}
      <DeviceSoftwareEndOfSupportContainer
        regionId={selectedRegionIds}
        buildingId={selectedBuildingIds}
      >
        <DeviceSoftwareEndOfLifeSummaryLayout />
      </DeviceSoftwareEndOfSupportContainer>
      {hasContinuity && (
        <BackupSummaryContainer
          regionId={selectedRegionIds}
          buildingId={selectedBuildingIds}
        >
          <ContinuitySection />
        </BackupSummaryContainer>
      )}
    </Flex>
  );
};

export default PortfolioLayout;
